import moment from 'moment-timezone'

// API refusal (HTTP 422) when a selection signs out of a date that has started.
export const ATTENDANCE_LOCKED_EVENT_STARTED = 'ATTENDANCE_LOCKED_EVENT_STARTED'

const TIMEZONE = 'Europe/Amsterdam'

// A date has started once its start time is no longer in the future. Times
// without an offset are read as Amsterdam time, like the API stores them.
export function hasDateStarted(startDateTime, now = moment()) {
  if (!startDateTime) return false
  const start = moment.tz(startDateTime, moment.ISO_8601, TIMEZONE)
  return start.isValid() && !start.isAfter(now)
}

export function isAttendanceLockedError(err) {
  return (
    err?.response?.status === 422 &&
    err?.response?.data?.error?.code === ATTENDANCE_LOCKED_EVENT_STARTED
  )
}
